<template>
	<v-menu
		v-model="menu"
		:close-on-content-click="false"
		:nudge-right="40"
		transition="scale-transition"
		:hide-details="hideDetails"
		offset-y
		min-width="290px"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-text-field
				v-model="localValue"
				:label="label"
				prepend-icon="mdi-calendar"
				:hide-details="hideDetails"
				readonly
				v-bind="attrs"
				v-on="on"
				naked
			></v-text-field>
		</template>
		<v-date-picker v-model="localValue" @input="menu = false" v-bind="$attrs"></v-date-picker>
	</v-menu>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
import AtomsMixins from './common/atoms.mixin';

export default {
	name: 'AppDatePickerMenu',
	mixins: [VModelMixin, AtomsMixins],

	props: {
		label: { type: String },
	},
	data() {
		return {
			menu: false,
		};
	},
};
</script>

<style scoped lang="scss"></style>
